export const settingPageColors = {
  background: "var(--sds-color-primitive-grey-50)",
  border: "var(--mono-grey-2)",
  textPrimary: "var(--sds-color-text-default-default)",
  textTertiary: "var(--sds-color-text-default-tertiary)",
  textSection: "var(--mono-grey-6)",
  textLabel: "var(--mono-grey-5)",
  textLabelMuted: "var(--mono-grey-4)",
  textValue: "var(--mono-navy)",
  link: "var(--pink-medium)",
  icon: "var(--mono-grey-6)",
  cardBackground: "var(--mono-white)",
  chipAdminBackground: "var(--pink-bg)",
  chipAdminText: "var(--pink-dark)",
};

export const settingPageGrey = {
  50: settingPageColors.background,
  200: settingPageColors.border,
  400: settingPageColors.textLabelMuted,
  500: settingPageColors.textLabel,
  600: settingPageColors.textSection,
};
